import React from 'react';
import { motion } from 'framer-motion';
import { Heart, Coins, Compass, Home, Sparkles } from 'lucide-react';
import { ProgressBar } from '../ui/ProgressBar';
import { themes, ThemeId } from '../../data/quizData';
interface ThemePhaseProps {
  onSelect: (themeId: ThemeId) => void;
}
const iconMap: Record<string, React.ReactNode> = {
  Heart: <Heart className="w-7 h-7" strokeWidth={1.25} data-id="element-243" />,
  Coins: <Coins className="w-7 h-7" strokeWidth={1.25} data-id="element-244" />,
  Compass: <Compass className="w-7 h-7" strokeWidth={1.25} data-id="element-245" />,
  Home: <Home className="w-7 h-7" strokeWidth={1.25} data-id="element-246" />,
  Sparkles: <Sparkles className="w-7 h-7" strokeWidth={1.25} data-id="element-247" />
};
export const ThemePhase = ({
  onSelect
}: ThemePhaseProps) => {
  return <motion.div className="w-full max-w-5xl mx-auto px-4 py-10 flex flex-col min-h-screen justify-center" initial={{
    opacity: 0,
    x: 20
  }} animate={{
    opacity: 1,
    x: 0
  }} exit={{
    opacity: 0,
    x: -20
  }} transition={{
    duration: 0.6
  }} data-id="element-248">
      <ProgressBar progress={25} label="Fase 2: Selección del Área de Consulta" data-id="element-249" />

      <div className="text-center mt-10 mb-12" data-id="element-250">
        <h2 className="font-cinzel tracking-wide mb-5" style={{
        color: '#D4AF37',
        fontSize: 'clamp(22px, 4vw, 30px)',
        fontWeight: 600
      }} data-id="element-251">
          SELECCIÓN DEL ÁREA DE CONSULTA
        </h2>
        <p className="font-sans mx-auto max-w-2xl" style={{
        color: '#E0D4BC',
        fontSize: '14.5px',
        lineHeight: 1.6,
        fontWeight: 400
      }} data-id="element-252">
          Seleccione la dimensión de su vida que requiere una triangulación
          inmediata del Oráculo. Su elección determinará el enfoque de los
          algoritmos de lectura.
        </p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5" data-id="element-253">
        {themes.map((theme, index) => <motion.button key={theme.id} onClick={() => onSelect(theme.id)} className="group relative flex flex-col items-start text-left p-7 bg-ink/60 border border-gold/30 rounded-sm overflow-hidden transition-all duration-300 hover:border-gold hover:shadow-[0_0_28px_rgba(212,175,55,0.55),inset_0_0_18px_rgba(212,175,55,0.08)]" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: index * 0.08,
        duration: 0.5
      }} whileHover={{
        y: -3
      }} whileTap={{
        scale: 0.99
      }} data-id="element-254">
            {/* Subtle hover sheen */}
            <div className="absolute inset-0 bg-gradient-to-br from-gold/5 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500 pointer-events-none" data-id="element-255" />

            {/* Icon */}
            <div className="mb-5 text-gold transition-transform duration-500 group-hover:scale-105" style={{
          color: '#D4AF37'
        }} data-id="element-256">
              {iconMap[theme.icon]}
            </div>

            {/* Title — uppercase, classic serif */}
            <h3 className="font-cinzel mb-3 tracking-wider" style={{
          color: '#D4AF37',
          fontSize: '15.5px',
          fontWeight: 600,
          letterSpacing: '0.08em'
        }} data-id="element-257">
              {theme.title}
            </h3>

            {/* Hairline gold divider */}
            <div className="w-10 h-px bg-gold/50 mb-4 group-hover:w-16 group-hover:bg-gold transition-all duration-500" data-id="element-258" />

            {/* Subtitle — compact sans-serif */}
            <p className="font-sans" style={{
          color: '#D9CCAE',
          fontSize: '13.5px',
          lineHeight: 1.55,
          fontWeight: 400
        }} data-id="element-259">
              {theme.subtitle}
            </p>

            {/* Index marker — small Roman/numeric tag */}
            <span className="absolute top-4 right-4 font-sans" style={{
          color: '#b8923d',
          fontSize: '10px',
          letterSpacing: '0.2em',
          fontWeight: 500,
          opacity: 0.7
        }} data-id="element-260">
              {String(index + 1).padStart(2, '0')}
            </span>
          </motion.button>)}
      </div>
    </motion.div>;
};